import { Observable } from 'rxjs';
import { RoleSkillSetup, RoleSkillSetupParams } from '../../interfaces/career-setup/role-skill-setup.interface';
import { BaseService } from '../base.service';
import { CommonSearchParam } from '../../interfaces/common-search-param.interface';
import { PageResponse } from '../../interfaces/page-response.interface';

export abstract class RoleSkillSetupService extends BaseService<RoleSkillSetup> {
  abstract getRoleSkills(params?: RoleSkillSetupParams): Observable<PageResponse<RoleSkillSetup>>;
  
  abstract override findAll(params: CommonSearchParam): Observable<PageResponse<RoleSkillSetup>>;
  abstract override find(id: string): Observable<RoleSkillSetup>;
  abstract override create(data: Partial<RoleSkillSetup>): Observable<RoleSkillSetup>;
  abstract override update(id: string, data: Partial<RoleSkillSetup>): Observable<RoleSkillSetup>;
  abstract updateStatus(id: string, isActive: boolean): Observable<RoleSkillSetup>;
  abstract override delete(id: string): Observable<void>;
}
